export default {

    Bills: 'Invoice|Invoices',
};
